/**
 * Where a document's bytes come from.
 *
 * A single shape, deliberately. The bytes are always fetched from the URL the
 * API minted for them — the same arrangement Shelcom uses, where an endpoint
 * returns a presigned URL carrying `Content-Disposition: inline` and the
 * renderer fetches that URL directly.
 *
 * This is a `type` rather than a bare string because the viewer needs two
 * things from a document that a string cannot carry both of: where to fetch it,
 * and the address to offer as "open in a new tab". They are the same value
 * today and may not stay that way — a short-lived signed URL is worth
 * re-minting for a fetch but not worth handing to a tab the reader may open an
 * hour later.
 */
export interface DocumentSource {
  /** The presigned URL to fetch and render. */
  url: string;
}

/** The URL a document can be opened at directly. */
export const directUrlOf = (source: DocumentSource): string => source.url;

/** Identity for effect dependencies, so a re-render with an equal-but-new
 *  object does not refetch a document that has not changed. */
export const sourceKeyOf = (source: DocumentSource): string => source.url;
